import { useHistory, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import {
  useProcessFacebookAuthCallback,
  useProcessGoogleAuthCallback
} from 'api/kms/ThirdPartyAuth/processAuthCallback.mutation';
import { Severity, usePushNotifications } from '../../NotificationService';

export const useThirdPartyAuthCallback = () => {
  const location = useLocation();
  const history = useHistory();
  const notify = usePushNotifications();

  const [facebookCallback, { data: facebookData }] = useProcessFacebookAuthCallback();
  const [googleCallback, { data: googleData }] = useProcessGoogleAuthCallback();

  const isGoogleCallback = location.pathname === '/third_party_auth/google';
  const isFacebookCallback = location.pathname === '/third_party_auth/facebook';

  const isCallback = isGoogleCallback || isFacebookCallback;

  useEffect(() => {
    if (isFacebookCallback) {
      const code = getCodeFromSearchParams();
      if (!code) return;

      facebookCallback({ variables: { code } });
    } else if (isGoogleCallback) {
      const code = getCodeFromSearchParams();
      if (!code) return;

      googleCallback({ variables: { code } });
    }
  }, []);

  const getCodeFromSearchParams = () => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code) {
      return code;
    } else {
      notify({
        title: 'Authentication failed',
        message: 'Something went wrong, please, try again.',
        severity: Severity.ERROR
      });
      history.push('/');
    }
  };

  useEffect(() => {
    const data = facebookData?.processFacebookAuthCallback || googleData?.processGoogleAuthCallback;
    if (!data) return;

    if (data.success) {
      window.location.href = '/';
    } else {
      notify({
        title: 'Error',
        message: `Authentication failed, please, try one more time. \n${data.errors}`,
        severity: Severity.ERROR
      });
      history.push('/');
    }
  }, [facebookData, googleData]);

  return {
    isCallback
  };
};
